import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "1. The service",
    paragraphs: [
      "Sellcraft is a mobile application that uses AI to identify items from photos, estimate prices and generate marketplace listings for eBay, Facebook Marketplace and Gumtree.",
      "These terms govern your use of the Sellcraft app and website.",
    ],
  },
  {
    title: "2. Subscriptions & billing",
    paragraphs: [
      "Paid plans (Starter and Pro) are billed through Google Play. Eligible new subscribers may receive a 3-day free trial, which converts to a paid subscription unless cancelled before the trial ends.",
      "You can cancel anytime in Google Play under Payments & subscriptions. Access continues until the end of the current billing period.",
    ],
  },
  {
    title: "3. Acceptable use",
    paragraphs: [
      "You are responsible for the items you list and for complying with the rules of each marketplace you post to. Do not use Sellcraft to list prohibited, stolen or counterfeit goods.",
    ],
  },
  {
    title: "4. AI-generated content",
    paragraphs: [
      "Price estimates, identifications and listing text are AI-generated suggestions. Always review a listing before publishing — final accuracy and pricing decisions are yours.",
    ],
  },
  {
    title: "5. Limitation of liability",
    paragraphs: [
      "Sellcraft is provided \"as is\" without warranties of any kind. We are not liable for losses arising from marketplace transactions or reliance on AI-generated estimates.",
    ],
  },
  {
    title: "6. Contact",
    paragraphs: [
      "Questions about these terms can be sent to support@sellcraft.app.",
    ],
  },
];

const TermsPage = () => (
  <LegalPage
    testId="terms-page"
    pageTitle="Terms of Service"
    lastUpdated="1 July 2026"
    sections={SECTIONS}
  />
);

export default TermsPage;
